module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"title":"您可以选择修改密码，修改完成后，即可使用<span style=\u0027color: #CF9155;\u0027>手机号和此密码</span>登录；若您直接跳过当前步骤不修改密码，您仍可使用<span style=\u0027color: #CF9155;\u0027>手机号和原来的密码</span>登录。","password-placeholder":"8-20位，同时包含数字和字母","set-password":"设置密码","confirm-password":"确认密码","document-title":"修改密码"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
